import { createFileRoute } from "@tanstack/react-router";
import RevisionSheetsGuide from "@/pages/resources/RevisionSheetsGuide";

const title = "Revision Sheets: How to Make Them + Template | System Atlas";
const description = "Make revision sheets from your course notes with a 7-part template, a worked biology example and a cover-test-check routine. Learn what to keep and cut.";
const url = "https://systematlas.fr/learn/revision-sheets";

export const Route = createFileRoute("/learn/revision-sheets")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "article" },
      { property: "og:url", content: url },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
    ],
    links: [
      { rel: "canonical", href: url },
      { rel: "alternate", hrefLang: "en", href: url },
      { rel: "alternate", hrefLang: "fr", href: "https://systematlas.fr/fr/learn/revision-sheets" },
      { rel: "alternate", hrefLang: "x-default", href: url },
    ],
    scripts: [{ type: "application/ld+json", children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Article",
      headline: "How to Make Revision Sheets (Template & Example)",
      description,
      datePublished: "2026-02-08",
      dateModified: "2026-10-22",
      inLanguage: "en",
      author: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      publisher: { "@type": "Organization", name: "System Atlas", url: "https://systematlas.fr" },
      mainEntityOfPage: url,
    }) }],
  }),
  component: RevisionSheetsGuide,
});
